/* Phone carousels: reviews, field test photos and feature cards drift slowly in an endless loop.
   A touch pauses them, swiping works as normal, and they pick up again a moment after the finger lifts. */
(function(){
if(!window.matchMedia)return;
var mq=matchMedia('(max-width: 820px)');
if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var SPEED=26; // pixels per second
var TARGETS=[['#reviews .cw','.ct'],['.gal',null],['.cards',null]];
var list=[],raf=0,last=0;

function now(){return performance.now()}
function loopW(r){return r.clone.getBoundingClientRect().left-r.first.getBoundingClientRect().left}

function setup(){
 TARGETS.forEach(function(t){
  [].forEach.call(document.querySelectorAll(t[0]),function(sc){
   if(sc._ptlc)return;
   var tr=t[1]?sc.querySelector(t[1]):sc;if(!tr)return;
   var items=[].slice.call(tr.children).filter(function(c){return !c.classList.contains('rv-clone')});
   if(items.length<2)return;
   items.forEach(function(c){var k=c.cloneNode(true);k.setAttribute('aria-hidden','true');k.classList.add('ptlc-clone');
    [].forEach.call(k.querySelectorAll('a,button,[tabindex]'),function(x){x.tabIndex=-1});tr.appendChild(k)});
   var r={sc:sc,tr:tr,first:items[0],clone:tr.children[items.length],pos:sc.scrollLeft,hold:0,vis:true,ours:false};
   sc._ptlc=r;sc.classList.add('ptlc');
   var stop=function(){r.hold=Infinity},go=function(){r.hold=now()+2500;r.pos=sc.scrollLeft};
   sc.addEventListener('touchstart',stop,{passive:true});sc.addEventListener('touchend',go,{passive:true});sc.addEventListener('touchcancel',go,{passive:true});
   sc.addEventListener('pointerdown',stop);sc.addEventListener('pointerup',go);
   sc.addEventListener('wheel',function(){r.hold=now()+2500},{passive:true});
   sc.addEventListener('scroll',function(){
    if(r.ours){r.ours=false;return}
    var L=loopW(r);if(L>0&&sc.scrollLeft>=L){sc.scrollLeft-=L}
    r.pos=sc.scrollLeft;if(r.hold!==Infinity)r.hold=Math.max(r.hold,now()+1200)},{passive:true});
   if('IntersectionObserver' in window){new IntersectionObserver(function(e){r.vis=e[0].isIntersecting}).observe(sc)}
   list.push(r)})});
 if(list.length&&!raf){last=0;raf=requestAnimationFrame(tick)}
}

function teardown(){
 list.forEach(function(r){[].forEach.call(r.tr.querySelectorAll('.ptlc-clone'),function(c){c.remove()});r.sc.classList.remove('ptlc');r.sc.scrollLeft=0;delete r.sc._ptlc});
 list=[];if(raf){cancelAnimationFrame(raf);raf=0}
}

function tick(t){
 var dt=last?Math.min(t-last,100)/1000:0;last=t;
 if(!document.hidden)list.forEach(function(r){
  if(!r.vis||now()<r.hold)return;
  var L=loopW(r);if(L<=0)return;
  r.pos+=SPEED*dt;if(r.pos>=L)r.pos-=L;
  r.ours=true;r.sc.scrollLeft=r.pos});
 raf=requestAnimationFrame(tick)}

function sync(){if(mq.matches)setup();else teardown()}
if(mq.addEventListener)mq.addEventListener('change',sync);else if(mq.addListener)mq.addListener(sync);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync);else sync();
})();
